import type { PersisterStorage } from './idb-persister-storage';

/**
 * True during the static/server render pass (Expo Router `web.output`).
 *
 * `react-native-web` reports `Platform.OS === 'web'` even when the bundle is
 * executed in Node for prerendering, so the platform flag can't distinguish
 * "browser" from "server". The absence of `window` is the reliable signal.
 */
export const isServerRender = typeof window === 'undefined';

/**
 * Inert storage used for the server render pass.
 *
 * Persisted Zustand stores rehydrate at module import. On the server there is
 * no user data, and the write-back that `persist` triggers from
 * `onRehydrateStorage` would call into AsyncStorage's web build, which
 * dereferences `window` and throws `ReferenceError: window is not defined`.
 * Returning an inert adapter lets every route render the logged-out / empty
 * shell; the client re-runs hydration against the real backing store on mount.
 */
export const noopStorage: PersisterStorage = {
  getItem: () => Promise.resolve(null),
  setItem: () => Promise.resolve(),
  removeItem: () => Promise.resolve(),
};
